import type { UUID } from '@protector/utils/types';
import type { AssigneePage } from '@protector/entities/assignee/models';

export const AssigneeActionsTypes = {
  LOAD_ASSIGNEES: '[Assignee] Load Assignees',
  LOAD_ASSIGNEES_SUCCESS: '[Assignee] Load Assignees Success',
  LOAD_ASSIGNEES_FAILURE: '[Assignee] Load Assignees Failure'
} as const;

export const LoadAssignees = (company_id: UUID, only_accounts_workers?: boolean) => {
  return {
    type: AssigneeActionsTypes.LOAD_ASSIGNEES,
    payload: { company_id, only_accounts_workers }
  };
};

export const LoadAssigneesSuccess = (assigneePage: AssigneePage) => {
  return {
    type: AssigneeActionsTypes.LOAD_ASSIGNEES_SUCCESS,
    payload: assigneePage
  };
};

export const LoadAssigneesFailure = (error: string) => {
  return {
    type: AssigneeActionsTypes.LOAD_ASSIGNEES_FAILURE,
    payload: error
  };
};
